/**
 * @module components\selfcare-raise-complaint\ProductListing
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
const axios = require('axios');
import store from '@/store';
import RaiseComplaintDialog from '../../common-components/raise-complaint-dialog/raise-complaint-dialog.vue';
import SelfRaiseTabHeading from '../../common-components/self-raise-tabHeading/self-raise-tabHeading.vue';
import GetCategoryListing from '../../../services/api/getCategoryListing';
import { mapState, mapGetters, mapMutations } from 'vuex';
import { getLang, getHelpTopicLength } from '../../../utilities/helperFunctions';
import GetProductName from '@/services/api/getProductName';
import sToast from '@/services/sToast';

@Component({
  name: 'LevelThreeCategory',
  components: {
    RaiseComplaintDialog,
    SelfRaiseTabHeading,
  },
  computed: {
    ...mapState(['raiseScreenTitle', 'productID']),
    ...mapGetters(['SUBCATEGORYLISTING']),
  },
  methods: {
    ...mapMutations(['subSubCategoryValue']),
  },
})
export default class LevelThreeCategory extends Vue {
  @Prop(String) id: string | undefined;
  @Prop(String) name: string | undefined;
  @Prop(String) url: string | undefined;

  /* variable decalartion */
  categoryListing = [];
  prodLength: number = null;
  imageName: string = '';
  selectedCategoryName: string = this.name
    ? this.name
    : this.$store.state.levelTwoCategory.levelTwoCategoryName;
  selectedCategoryID: any = this.id
    ? this.id
    : this.$store.state.levelTwoCategory.levelTwoCategoryID;
  helpTopicCount = null;

  get mode() {
    return this.$store.state.mode;
  }

  get lang() {
    return this.$store.state.lang;
  }

  /* methods */
  getProductListing(catID: any) {
    let catInfo = {
      categoryID: catID,
      subLevel: 'level-3',
      subsubLevel: 'level-4',
      language: getLang(this.lang),
    };
    GetCategoryListing.getAllSubCategory(catInfo).then(response => {
      store.commit('subSubCategoryValue', response.data);
      this.categoryListing = this.$store.state.subSubCategoryListing;
      this.prodLength = this.$store.state.subSubCategoryListing.length;
    });
  }

  /* navigate to subcategory page */
  async navigateToSubCategory(catName: string, catID: any, catIndex: any) {
    store.commit('setSubCategoryName', this.categoryListing[catIndex].subCategoryEnglish);
    let productUrl = 'product-related';
    productUrl = catName
      .toLowerCase()
      .split(' ')
      .join('-');

    //for care-user activity records
    let value = {
      key: 'subCategoryThree',
      name: catName,
      route: 'levelThree',
    };
    store.commit('RAISECOMPLAINTARRAY', value);

    //for subcategory Call "level-4"
    let subCatThree = {
      levelThreeCategoryName: catName,
      levelThreeCategoryID: catID,
      levelThreeCategoryIndex: catIndex,
      levelThreeEngTitle: this.categoryListing[catIndex].subCategoryEnglish,
    };
    store.commit('setlevelThreeCategory', subCatThree);
    store.commit('setraiseTitle', catName);

    if (this.categoryListing[catIndex].subCategoryPresent) {
      this.$router.push({
        name: 'SubSubCategory',
        params: { url: productUrl, name: catName, id: catIndex },
      });
    } else {
      let attachment = this.categoryListing[catIndex].attachmentRequired;
      let attachementvalue = {
        attachmentRequired: attachment,
        topicName: catName,
      };
      store.commit('setAttachment', attachementvalue);

      try {
        if (
          store.state.validMainCategoryIds.includes(store.state.mainCategoryInfo.mainCategoryID) &&
          !store.state.notValidSubCategoryIds.includes(
            store.state.levelTwoCategory.levelTwoCategoryID
          )
        ) {
          if ('SELFCARE' === this.$store.getters.getSource) {
            const response = await GetProductName.getProductName(
              store.getters.getProductNamePayload
            );

            if (
              response.data.responseStatus === 'S' &&
              response.data.payload &&
              response.data.payload.productCode
            ) {
              if (store.state.mainCategoryInfo.mainCategoryID == '5f35024be47a6b7353867279') {
                store.commit('setSelectedProductForHistory', response.data.payload.productCode);
                this.$router.push({
                  name: 'TransactionHistory',
                });
              } else {
                store.state.initialFilters = {
                  WALLET: [{ key: '2', value: response.data.payload.productCode }],
                };
                store.commit('setSelectedProductForHistory', 'WALLET');
                this.$router.push({
                  name: 'TransactionHistory',
                });
              }
            } else {
              sToast.show({
                message: response.data.responseDescription,
                intent: 'error',
                timeout: 8000,
              });
            }
          } else {
            this.$router.push({
              name: 'HelpRaiseComplaint',
            });
          }
        } else {
          // this.$router.push({
          //   name: 'HelpRaiseComplaint',
          //   params: {
          //     attachmentRequired: attachment,
          //     pageName: cardName,
          //     attachmentName: attachmentName,
          //   },
          // });

          getHelpTopicLength(data => {
            this.helpTopicCount = data.length;
            if (!this.helpTopicCount) {
              this.$router.push({ name: 'HelpRaiseComplaint' });
            } else {
              this.$router.push({
                name: 'HelpTopics',
                params: { filterVisible: 'false', isHelpTopicData: 'true' },
              });
            }
          });
        }
      } catch (e) {
        console.error(e);
      }
    }

    //Google Analytics
    this.$gtag.event('click', {
      event_category: `SelfCare`,
      event_label: `Clicked ${catName}`,
    });
  }

  /* mounted function */
  mounted() {
    // for new category flow implementation -- id changes
    store.commit('CLEAR_LEVELFOURCATEGORY');
    this.getProductListing(this.selectedCategoryID);
  }
}
